import { css } from "@emotion/css";
import Flex from "../../components/atom/flex";
import PageContent from "../../components/molecule/pageContent";

const pageCSS = css`
    #first {
        display: flex;
        align-items: center; 
        padding: 100px 0px;
        box-sizing: border-box;
        
        &::before {
            content: '';
            top: 0;
            left: 0;
            position: absolute;
            z-index: -1;
            height: 100%;
            width: 100%;
            opacity: .7;
            background-image: url('/img/bg_1.jpeg');
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
        }

        .kt-flex {
            height: max-content;
            width: 100%; 
            max-width: 1280px; 
            margin: auto;

            img {
                max-width: 80%;
            }

            p {
                font-family: Courier New, Arial;
                font-size: 2rem;
                font-weight: bold;
                text-align: center;
            }
        }
    }

    #second {
        background-color: #734332;
        color: #ffffff;
        padding: 10% 10% 10px 10%;
        box-sizing: border-box;
        text-align: center; 
        font-weight: bold;

        img {
            width: 100%; 
            margin-bottom: 20;
            border: 1px solid #c1c1c1;
            border-radius: 10px;
        }

        #p1 {
            font-family: 'Source Code Pro', Arial;
            font-size: 1.75rem;
        }
            
        #p2 {
            font-family: 'Pacifico', cursive;
            font-size: 1.5rem;
        }
    }

    #third {
        background-color: #f1e1dd;
        text-align: center;
        display: flex; 
        flex-direction: column;
        justify-content: center; 
        padding: 40px; 
        box-sizing: border-box;

        h2 {
            color: #cc4331;
            font-size: 3rem;
        }

        p.kt-aux {
            font-family: 'Lato'; 
            color: #cc4331;
            font-size: 1.25rem;
            font-weight: bold;
            margin-top: 0;
            white-space: pre-wrap;
        }

        div {
            margin-top: 50px;
            font-family: "Courier New, Arial"; 
            font-size: 1.1rem; 
        }
    }
`;

const Home = () => {
    return (<div className={pageCSS}>
        <PageContent id="first">
            <Flex 
                wrap
                gap={150}
                align="center" 
                justify="center"
            >
                <img
                    src="/img/logo.png"
                    alt="Logo"
                />
                <p>
                    UNIVERSO AUTORAL EM<br/>
                    CONSTANTE CRIAÇÃO
                </p>
            </Flex>
        </PageContent>
        <PageContent id="second">
            <img 
                src="/img/bg_2.jpeg"
                alt="Background"
            />
            <p id="p1">ENTRE. RESPIRE. INSPIRE-SE. VOCÊ ESTÁ EM CASA</p>
            <p id="p2">Um lugar onde idéias florescem, conversas ganham alma e arte encontra o seu lar.</p>
        </PageContent>
        <PageContent id="third">
            <h2>ZYZA</h2>
            <p className="kt-aux">UNIVERSO AUTORAL</p>
            <p className="kt-aux">Criação    *    Inspiração    *    Encontro</p>
            <div>
                <p>O Universo ZYZA nasceu do desejo de transformar idéias em experiências.</p>
                <p>Aqui palavras, arte, natureza e sensibilidade se encontram para dar forma a livros, pinturas, fotografias, espaços e projetos que convidam à contemplação.</p>
                <p>Cada criação nasce do mesmo propósito: despertar significado, cultivar a beleza e criar encontros.</p>
            </div>
        </PageContent>
    </div>)
}

export default Home;